module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slate-int-calculator-output"
    }
  }, [_c('back-button', {
    on: {
      "backButtonClick": _vm.goBack
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "slate-int-calculator-result"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-0b06b55a!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!./components/CalculatorOutput.vue
// module id = 106
// module chunks = 0